// Fix for broken remote validation in DX 12.2.6
// http://www.devexpress.com/Support/Center/Question/Details/B231635
// remove me when fixed
if ($.validator) {
    $.validator.methods.remote = function (value, element, param) {
        var editor = MVCx.GetEditorByElement(element);
        if (editor && param && param.data && param.data[editor.name])
            param.data[editor.name] = editor.GetValueString();

        if (this.optional(element))
            return "dependency-mismatch";

        var previous = this.previousValue(element);
        if (!this.settings.messages[element.name])
            this.settings.messages[element.name] = {};
        previous.originalMessage = this.settings.messages[element.name].remote;
        this.settings.messages[element.name].remote = previous.message;

        param = typeof param == "string" && { url: param } || param;

        if (previous.old !== value) {
            previous.old = value;
            var validator = this;
            this.startRequest(element);
            var data = {};
            data[element.name] = value;
            $.ajax($.extend(true, {
                url: param,
                mode: "abort",
                port: "validate" + element.name,
                dataType: "json",
                data: data,
                success: function (response) {
                    validator.settings.messages[element.name].remote = previous.originalMessage;
                    var valid = response === true;
                    if (valid) {
                        var submitted = validator.formSubmitted;
                        validator.prepareElement(element);
                        validator.formSubmitted = submitted;
                        validator.successList.push(element);
                        validator.showErrors();
                    } else {
                        var errors = {};
                        var message = (previous.message = response || validator.defaultMessage(element, "remote"));
                        errors[element.name] = $.isFunction(message) ? message(value) : message;
                        validator.showErrors(errors);
                    }
                    previous.valid = valid;
                    validator.stopRequest(element, valid);
                }
            }, param));
            return "pending";
        } else if (this.pending[element.name]) {
            return "pending";
        }
        return previous.valid;
    }
}


